import { VStack, Button, Text } from "@chakra-ui/react";
import type { FormStepProps } from "../../interfaces";
import FormInputWraper from "../../Components/FormInputWrapper";
import SportsRadioInputs from "../../Components/SportsRadioInputs";
import RegisterHeading from "../../Components/RegisterHeading";
import { FormWrapper } from "../../Components/LayoutComponents";
import { INPUT_SPACING } from "../../RegisterPage";
import { Controller } from "react-hook-form";
import { useEffect } from "react";
import GenderAndProfileInput from "./GenderAndProfileInput";
import BirthdayInput from "./BirthdayInput";
import HeightWeightAndRestHeartRate from "./HeightWeightAndRestHeartRate";
import { useTranslations } from "next-intl";

const StepTwo = (props: FormStepProps) => {
  const { onSubmit, RegisterMutationResult, FormController, goBack } = props;
  const watched_type = FormController.watch("type");
  const watched_gender = FormController.watch("gender");
  const watched_year = FormController.watch("bday_year");
  const t = useTranslations("pages.register");

  useEffect(() => {
    if (watched_type) {
      FormController.setValue(
        "rest_heart_rate",
        watched_type === "athlete" ? 55 : 70
      );
    }
    if (watched_gender && watched_year) {
      const currentYear = new Date().getFullYear();
      if (watched_year < 1930 || watched_year > currentYear) {
        FormController.setValue(
          "max_heart_rate",
          undefined
        );
      } else {
        const athleteAge = currentYear - FormController.watch("bday_year");
        FormController.setValue(
          "max_heart_rate",
          watched_gender === "MALE" ? 220 - athleteAge : 226 - athleteAge
        );
      }

    }
  }, [watched_type, watched_gender, watched_year]);

  return (
    <FormWrapper>
      <RegisterHeading
        color="brandOrange.500"
        fontSize="4xl"
        mb="8"
      >
        {t("bioData")}
      </RegisterHeading>
      <VStack spacing={INPUT_SPACING} w="full">
        <FormInputWraper
          label={t("mainSport")}
          FormController={FormController}
          field_name="sport_id"
          color="brandOrange.500"
          key="sport_id"
          isRequired
        >
          <Controller
            control={FormController.control}
            name="sport_id"
            rules={{ required: t("sportMessage") }}
            render={({ field }) => (
              <SportsRadioInputs
                {...field}
                maxOptions={1}
                colorScheme="brandOrange"
                value={field.value ? [field.value] : []}
                onChange={([value]) => {
                  if (field.value === value) return;
                  FormController.setValue("plan_id", "");
                  FormController.setValue("coach_id", "");
                  field.onChange(value);
                }}
              />
            )}
          />
        </FormInputWraper>

        <GenderAndProfileInput {...props} />

        <BirthdayInput {...props} />

        <HeightWeightAndRestHeartRate {...props} />
      </VStack>

      <VStack spacing={5} align="start" w="full" mt="6">
        {RegisterMutationResult?.error && (
          <Text color="red.500">{RegisterMutationResult?.error.message}</Text>
        )}
        <Button
          colorScheme="brandOrange"
          onClick={FormController.handleSubmit(onSubmit)}
          isLoading={RegisterMutationResult?.loading}
        >
          {t("nextAthleteButton2")}
        </Button>
        <Button colorScheme="gray" variant="link" onClick={goBack}>
          {t("backAthleteButton1")}
        </Button>
      </VStack>
    </FormWrapper>
  );
};

export default StepTwo;
